module.exports = __webpack_public_path__ + "static/media/icon_front_step.a5965618.svg";